const activityScoringMetadata = {
  fitness: {
    multipliers: {
      vigorous_duration: 0.25,
      moderate_duration: 0.05,
      piggy_bank: 4
    },
    max: 6,
    max_score: 4,
    min: 0
  },
  rest: {
    multipliers: {
      duration: 0.125
    },
    max: 2
  },
  sunshine: {
    multipliers: {
      duration: 0.125
    },
    max: 2
  },
  sleep: {
    multipliers: {
      minutes: (1 / 120)
    },
    start: -0.5,
    max: 4,
    min: 0
  },
  water: {
    multipliers: {
      cups: 0.5,
      fruit: 0.5,
      vegetables: 0.5
    },
    max: 4,
    min: 0
  },
  food: {
    multipliers: {
      yellow: -0.25,
      red: -0.5,
      green: 0.25
    },
    start: 0,
    min: -4,
    max: 4
  },
  cleanliness: {
    multipliers: {
      teeth: 0.5,
      body: 0.5,
      floss: 0.5
    },
    min: 0,
    max: 2
  }
};

export {activityScoringMetadata};



// WEBPACK FOOTER //
// ./src/util/ActivityMetadata.js